export class OSDetectorClient {
  private static readonly DEFAULT_OS = 'unknown';
  private static readonly DEFAULT_OS_VERSION = 'unknown';

  public async detect(): Promise<{ os: string; osVersion: string } | { ua: string }> {
    // modern method
    if (typeof navigator.userAgentData?.getHighEntropyValues !== 'undefined') {
      try {
        const data = await navigator.userAgentData.getHighEntropyValues(['platform', 'platformVersion']);

        const os = data.platform ?? OSDetectorClient.DEFAULT_OS;
        const osVersion = data.platformVersion?.replace(/_/g, '.') ?? OSDetectorClient.DEFAULT_OS_VERSION;

        return { os, osVersion };
      } catch {}
    }

    return { ua: navigator.userAgent };
  }

  public extract(ua: string): { os: string; osVersion: string } {
    let os = OSDetectorClient.DEFAULT_OS;
    let osVersion = OSDetectorClient.DEFAULT_OS_VERSION;

    try {
      if (ua.includes('Windows NT 10.0')) {
        os = 'Windows';
        osVersion = '10';
      } else if (ua.includes('Windows NT 6.3')) {
        os = 'Windows';
        osVersion = '8.1';
      } else if (ua.includes('Windows NT 6.2')) {
        os = 'Windows';
        osVersion = '8';
      } else if (ua.includes('Windows NT 6.1')) {
        os = 'Windows';
        osVersion = '7';
      } else if (ua.includes('Mac OS X')) {
        os = 'macOS';

        const match = /Mac OS X ([\d_]+)/.exec(ua);

        if (match) {
          osVersion = match[1].replace(/_/g, '.');
        }
      } else if (ua.includes('Android')) {
        os = 'Android';

        const match = /Android\s([\d.]+)/.exec(ua);

        if (match) {
          osVersion = match[1];
        }
      } else if (/iPhone|iPad|iPod/.test(ua)) {
        os = 'iOS';

        const match = /OS (\d+[_.]?\d*) like Mac OS X/.exec(ua);

        if (match) {
          osVersion = match[1].replace(/_/g, '.');
        }
      } else if (ua.includes('Linux')) {
        os = 'Linux';

        // try to detect Chrome OS
        if (ua.includes('CrOS')) {
          os = 'Chrome OS';

          const match = /CrOS [\w]+ ([\d.]+)/.exec(ua);

          if (match) {
            osVersion = match[1];
          }
        }
      } else if (ua.includes('PlayStation')) {
        os = 'PlayStation';

        const match = /PlayStation (\d+)/.exec(ua);

        if (match) {
          osVersion = match[1];
        }
      } else if (ua.includes('Xbox')) {
        os = 'Xbox';
      } else if (/SmartTV|TV|Tizen|Web0S/i.test(ua)) {
        os = 'Smart TV';
      }
    } catch {}

    return { os, osVersion };
  }
}

export const osDetector = new OSDetectorClient();
